<template>
    <div class="about-container" v-gsap-fade-up="{ offset: 30, duration: 0.9 }" id="about">
        <div class="title" v-gsap-fade-up="{ delay: 0.1 }">{{ $t("about.title") }}</div>
        <div class="content">
            <div class="row" v-gsap-fade-up="{ delay: 0.15 }">
                <p>{{ $t("about.row1.left") }}</p>
                <img src="@/assets/smile.gif" alt="Smile" class="graphic-smile">
                <p>{{ $t("about.row1.right") }}</p>
            </div>
            <div class="row" v-gsap-fade-up="{ delay: 0.25 }">
                <p>{{ $t("about.row2.left") }}</p>
                <img src="@/assets/butterfly.gif" alt="Butterfly" class="graphic-butterfly">
            </div>
            <div class="row" v-gsap-fade-up="{ delay: 0.35 }">
                <div class="graphic-waves"></div>
                <p>{{ $t("about.row3.right") }}</p>
            </div>
            <div class="row" v-gsap-fade-up="{ delay: 0.45 }">
                <p>{{ $t("about.row4.left") }}</p>
                <div class="graphic-waves-small"></div>
            </div>
            <div class="stats-grid">
                <div class="stat-item" v-gsap-fade-up="{ offset: 20 }">
                    <div class="stat-number">{{ $t("about.stats.experts.number") }}</div>
                    <div class="stat-label">{{ $t("about.stats.experts.label") }}</div>
                </div>
                <div class="stat-item" v-gsap-fade-up="{ offset: 20, delay: 0.05 }">
                    <div class="stat-number">{{ $t("about.stats.released.number") }}</div>
                    <div class="stat-label">{{ $t("about.stats.released.label") }}</div>
                </div>
                <div class="stat-item" v-gsap-fade-up="{ offset: 20, delay: 0.1 }">
                    <div class="stat-number">{{ $t("about.stats.ongoing.number") }}</div>
                    <div class="stat-label">{{ $t("about.stats.ongoing.label") }}</div>
                </div>
                <div class="stat-item" v-gsap-fade-up="{ offset: 20, delay: 0.15 }">
                    <div class="stat-number">{{ $t("about.stats.best.number") }}</div>
                    <div class="stat-label">{{ $t("about.stats.best.label") }}</div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "AboutUs",
  };
  </script>
  
  <style scoped>
  .about-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 5vw;
    padding-top: 32px;
    padding-bottom: 32px;
    position: relative;
  }

  .title {
    display: flex;
    justify-content: start;
    align-items: center;
    position: sticky;
    top: 128px;
    align-self: flex-start;
    font-size: clamp(24px, 3vw, 48px);
    font-weight: 300;
    text-transform: uppercase;
    white-space: nowrap;
    flex-shrink: 0;
    height: 82px;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0;
    max-width: 60%;
  }

  .row {
    display: flex;
    align-items: center;
    width: 100%;
    height: 82px;
    white-space: nowrap;
  }

  .row p {
    margin: 0;
    font-size: clamp(22px, 2.86vw, 55px);
    font-weight: 300;
    text-transform: uppercase;
    line-height: 0.8;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .graphic-smile {
    flex: 1;
    min-width: clamp(40px, 5vw, 80px);
    width: 100%;
    height: auto;
    object-fit: fill;
    margin: 0 clamp(12px, 1.5vw, 24px);
  }

  .graphic-butterfly {
    flex: 1;
    min-width: clamp(60px, 8vw, 120px);
    width: 100%;
    height: auto;
    object-fit: fill;
    margin-left: clamp(12px, 1.5vw, 24px);
  }

  .graphic-waves {
    flex: 1;
    min-width: clamp(80px, 10vw, 160px);
    width: 100%;
    height: 48px;
    object-fit: fill;
    margin-right: clamp(12px, 1.5vw, 24px);
    border-radius: 1000px;
    background: url("/src/assets/wawes.gif");
  }

  .graphic-waves-small {
    flex: 1;
    min-width: clamp(40px, 5vw, 80px);
    width: 100%;
    height: 48px;
    object-fit: fill;
    border-radius: 1000px;
    margin-left: clamp(12px, 1.5vw, 24px);
    background: url("/src/assets/wawes2.gif");
  }

  .stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    width: 100%;
    gap: clamp(16px, 2vw, 32px);
    margin-top: clamp(32px, 4vw, 64px);
    position: relative;
  }

  .stats-grid::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      #ffffff50 0%,
      #ffffff50 calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 0%
    );
    transform: translateY(-50%);
    z-index: 1;
  }

  .stats-grid::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: linear-gradient(
      to bottom,
      #ffffff50 0%,
      #ffffff50 calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% - clamp(8px, 1vw, 16px)),
      transparent calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 calc(50% + clamp(8px, 1vw, 16px)),
      #ffffff50 100%
    );
    transform: translateX(-50%);
    z-index: 1;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: clamp(24px, 3vw, 48px);
    box-sizing: border-box;
    position: relative;
    z-index: 2;
  }

  .stat-number {
    font-size: clamp(48px, 8vw, 120px);
    font-weight: 300;
    color: #fff;
    line-height: 1;
    margin-bottom: clamp(8px, 1vw, 16px);
  }

  .stat-label {
    font-size: clamp(12px, 1.5vw, 18px);
    font-weight: 300;
    text-transform: uppercase;
    color: #fff;
    text-align: center;
    letter-spacing: clamp(1px, 0.2vw, 2px);
  }

  @media screen and (max-width: 768px) {
    .about-container {
      flex-direction: column;
      gap: 32px;
      padding-left: 5%;
      padding-right: 5%;
      box-sizing: border-box;
      overflow-x: hidden;
    }

    .title {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: static;
    }

    .content {
      max-width: 100%;
      width: 100%;
      transform: scale(1);
    }

    .row {
      overflow-x: hidden;
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
    }

    .row p {
      font-size: clamp(16px, 4vw, 22px);
      line-height: normal;
    }

    .graphic-butterfly, .graphic-smile, .graphic-waves, .graphic-waves-small {
      display: none;
    }
  }
  </style>
  